export const FETCH_MODULES = 'FETCH_MODULES';
export const FETCH_MODULES_RESOLVED = 'FETCH_MODULES_RESOLVED';

export function fetchModulesRequest() {
  return {
    type: FETCH_MODULES
  };
}

export function fetchModulesResolved(modules, meta = null) {
  return {
    type: FETCH_MODULES_RESOLVED,
    modules,
    meta
  };
} 